import { useCallback, useState } from "react";

export type SelectedValues = {
  [key in string]: boolean | undefined;
};

export const useSelect = (initialValue?: SelectedValues) => {
  const [state, setState] = useState<SelectedValues>(initialValue || {});

  const toggleState = useCallback((key: string | SelectedValues) => {
    if (typeof key === "object") {
      setState(key);
    } else if (key === "all") {
      setState(currentValue => {
        if (currentValue?._all) {
          return {};
        } else {
          return { _all: true };
        }
      });
    } else {
      setState(currentState => {
        let initialState = currentState;

        if (currentState?._all) {
          initialState = {};
        }

        if (currentState?.[key]) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { [key]: k, ...rest } = initialState;

          return rest;
        } else {
          return { ...initialState, [key]: true };
        }
      });
    }
  }, []);

  return [state, toggleState] as const;
};
